import React from "react";

export default function TradeContact({
  tradeContact,
  onClickEditTradeContact,
  onDeleteContactFromList
}) {
  return (
    <li>
      <div className="text">{`${tradeContact.first_name} ${tradeContact.last_name}`}</div>
      <div className="ds-buttonGroup _spacedButtons">
        <button className="ds-btn --micro _link" onClick={onClickEditTradeContact(tradeContact)} data-testid='edit-trade-contact'><i className="materialIcon --micro -subtler">edit</i></button>
        <button className="ds-btn --micro _link" onClick={onDeleteContactFromList(tradeContact.id)} data-testid='delete-contact'><i className="materialIcon --micro -danger">close</i></button>
      </div>
    </li>
  )
}



// WEBPACK FOOTER //
// ./src/features/contacts/components/TradeContact.js